import { render, staticRenderFns } from "./HeaderNavigation.vue?vue&type=template&id=3ace25b0"
import script from "./HeaderNavigation.vue?vue&type=script&lang=ts"
export * from "./HeaderNavigation.vue?vue&type=script&lang=ts"
import style0 from "./HeaderNavigation.vue?vue&type=style&index=0&id=3ace25b0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports